import Vue from "vue"
import { store } from "@/store/stores"
import access from "./customerHubPreferences"
import { BODY_METRICS } from "./mescanHealthData"

export const HUB_DISPLAY_GROUPS = [
  { key: "training", label: "Training", items: [{ key: "units", label: "Trainingseinheiten" }, { key: "time", label: "Trainingszeit" }, { key: "days", label: "Aktive Trainingstage" }, { key: "visits", label: "Studiobesuche" }] },
  { key: "movement", label: "Bewegung", items: [{ key: "steps", label: "Schritte" }, { key: "distanceMeters", label: "Distanz" }, { key: "activeEnergyKilocalories", label: "Aktive Kalorien" }, { key: "totalEnergyKilocalories", label: "Gesamtverbrauch" }] },
  { key: "sleep-heart", label: "Schlaf & Herz", items: [{ key: "sleepSeconds", label: "Schlaf" }, { key: "heartRate", label: "Puls" }, { key: "restingHeartRate", label: "Ruhepuls" }, { key: "hrvRmssdMillis", label: "Herzratenvariabilität" }, { key: "oxygenSaturationPercentage", label: "Sauerstoffsättigung" }] },
  { key: "body", label: "Körper & MeScan", items: BODY_METRICS.map(({ key, label }) => ({ key, label })) },
]
const keyFor = owner => `roody:customer-hub:display:${owner}`
const defaults = () => ({ hidden: {}, timeSource: "workouts" })
function clean(value) {
  const hidden = {}
  for (const group of HUB_DISPLAY_GROUPS) hidden[group.key] = group.items.map(item => item.key).filter(key => Array.isArray(value?.hidden?.[group.key]) && value.hidden[group.key].includes(key))
  return { hidden, timeSource: value?.timeSource === "checkins" ? "checkins" : "workouts" }
}

// Only presentation choices are persisted, never activity or health records.
class CustomerHubDisplayPreferences {
  constructor() { this.state = Vue.observable({ owner: "", ...defaults(), error: "" }); this.token = "" }
  ensure() {
    if (!this.unwatch) this.unwatch = store.watch(() => `${access.isEnabled()}:${access.state.userId}:${access.state.revision}`, () => this.ensure())
    const identity = access.identity(), owner = access.isEnabled() ? identity.userId : ""
    if (this.state.owner !== owner || this.token !== identity.token) {
      this.token = identity.token
      let value = defaults()
      if (owner) try { value = clean(JSON.parse(localStorage.getItem(keyFor(owner)) || "{}")) } catch (_) { /* Defaults also work without storage. */ }
      Object.assign(this.state, { owner, ...value, error: "" })
    }
    return Boolean(owner)
  }
  visible(group, key) { this.ensure(); return !this.state.hidden[group]?.includes(key) }
  timeSource() { this.ensure(); return this.state.timeSource }
  setVisible(group, key, visible) {
    if (!this.ensure() || !HUB_DISPLAY_GROUPS.find(item => item.key === group)?.items.some(item => item.key === key)) return
    const keys = new Set(this.state.hidden[group] || [])
    if (visible) keys.delete(key); else keys.add(key)
    this.state.hidden = { ...this.state.hidden, [group]: [...keys] }
    this.save()
  }
  setTimeSource(value) { if (this.ensure() && ["workouts", "checkins"].includes(value)) { this.state.timeSource = value; this.save() } }
  save() {
    if (!this.ensure()) return
    try { localStorage.setItem(keyFor(this.state.owner), JSON.stringify(clean(this.state))); this.state.error = "" }
    catch (_) { this.state.error = "Deine Auswahl gilt für diese Sitzung. Sie konnte auf diesem Gerät nicht gespeichert werden." }
  }
}
export default new CustomerHubDisplayPreferences()

